import { render, staticRenderFns } from "./VHeaderEdit.vue?vue&type=template&id=1723c644&scoped=true"
import script from "./VHeaderEdit.vue?vue&type=script&lang=js"
export * from "./VHeaderEdit.vue?vue&type=script&lang=js"
import style0 from "./VHeaderEdit.vue?vue&type=style&index=0&id=1723c644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1723c644",
  null
  
)

export default component.exports